// extracted by mini-css-extract-plugin
export default {"submitButton":"ChangePassword_submitButton__yYJVb"};